import { reactive } from 'vue'

export default reactive<any>({
  item: null,
  answers: [],
  question: '',
  selectedAnswer: null,
})
